import React, { useEffect, useRef } from 'react';
import s from './Tabs.module.scss';
import c from 'classnames';

interface Tab {
  content: React.ReactNode;
  id: string;
  label: string;
}

interface TabsProps {
  activeTab: number;
  onTabClick: (tabId: number) => void;
  tabs: Tab[];
  className?: string;
  classNameTabs?: string;
  style?: 'small' | 'medium';
}

const Tabs: React.FC<TabsProps> = ({
  activeTab,
  tabs,
  onTabClick,
  className,
  classNameTabs,
  style,
}) => {
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const lineRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const activeTabTest = tabRefs.current[activeTab];
    const line = lineRef.current;

    if (activeTabTest && line) {
      const tabColor = activeTabTest.getAttribute('data-tab-color');
      line.style.left = `calc(${activeTabTest.offsetLeft}px + 12px)`;
      line.style.width = `calc(${activeTabTest.offsetWidth}px - 22px)`;
      line.style.backgroundColor = tabColor || '';
    }
  }, [activeTab]);
  return (
    <div className={c(className, style === 'medium' && s.medium)}>
      <div className={c(s.tabs, classNameTabs)}>
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            className={c(s.tab, activeTab === index && s.activeTab)}
            onClick={() => {
              onTabClick(index);
            }}
            ref={(el) => {
              tabRefs.current[index] = el;
            }}
            data-label={tab.label}
          >
            {tab.label}
          </button>
        ))}
        <span className={s.tabIndicator} ref={lineRef} />
      </div>
      <div>
        {tabs.map((tab, index) => (
          <div
            key={tab.id}
            className={c(s.tabContent, activeTab === index && s.activeContent)}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
